import { render } from "./ResumeEditor.vue?vue&type=template&id=34f99578&scoped=true"
import script from "./ResumeEditor.vue?vue&type=script&lang=js"
export * from "./ResumeEditor.vue?vue&type=script&lang=js"

import "./ResumeEditor.vue?vue&type=style&index=0&id=34f99578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f99578"]])

export default __exports__